import { safeJsonParse } from '@vietmeet/js-utils/json';
import { vietmeetLocalStorage } from '@vietmeet/js-utils/vietmeet-local-storage';
import { pick } from 'lodash-es';
import { isEmbedded } from '../util/embedUtils';
import { parseURLParams } from '../util/parseURLParams';
import { browser } from '../vietmeet-lib';
import logger from './logger';
import WHITELIST from './whitelist';
/**
 * Handles changes of the fake local storage.
 *
 * @returns {void}
 */
function onFakeLocalStorageChanged() {
    APP.API.notifyLocalStorageChanged(vietmeetLocalStorage.serialize(['vietmeetLocalStorage']));
}
/**
 * Checks if the local storage of the host page needs to be used instead vietmeet's local storage.
 *
 * @param {Object} urlParams - Object with parsed URL params.
 * @returns {boolean} - True if the local storage of the host page needs to be used instead vietmeet's local storage
 * and false otherwise.
 */
function shouldUseHostPageLocalStorage(urlParams) {
    // NOTE: normally the url params and the config will be merged into the redux store. But we want to setup the local
    // storage as soon as possible, the store is not created yet and the merging of the URL params and the config
    // haven't been executed yet. That's why we need to manually parse the URL params and also access the config through
    // the global variable.
    if (urlParams['config.useHostPageLocalStorage'] === true
        || (typeof config === 'object' && config.useHostPageLocalStorage)) {
        return true;
    }
    if (vietmeetLocalStorage.isLocalStorageDisabled()) { // We have detected that ou own local storage is not working.
        return true;
    }
    if (browser.isWebKitBased() && isEmbedded()) {
        // WebKit browsers don't persist local storage for third-party iframes.
        return true;
    }
    return false;
}
/**
 * Performs initial setup of the vietmeetLocalStorage.
 *
 * @returns {void}
 */
function setupVietMeetLocalStorage() {
    // @ts-ignore
    const urlParams = parseURLParams(window.location);
    if (shouldUseHostPageLocalStorage(urlParams)) {
        try {
            let localStorageContent = safeJsonParse(urlParams['appData.localStorageContent']);
            // We need to disable the local storage before setting the data in case the browser local storage doesn't
            // throw exception (in some cases when this happens the local storage may be cleared for every session.
            // Example: when loading meet from cross-domain with the IFrame API with Brave with the default
            // configuration). Otherwise we will set the data in the browser local storage and then switch to the dummy
            // local storage from vietmeetLocalStorage and we will loose the data.
            vietmeetLocalStorage.setLocalStorageDisabled(true);
            if (typeof localStorageContent === 'object') {
                if (!isEmbedded()) {
                    localStorageContent = pick(localStorageContent, WHITELIST);
                }
                Object.keys(localStorageContent).forEach(key => {
                    vietmeetLocalStorage.setItem(key, localStorageContent[key]);
                });
            }
        }
        catch (error) {
            logger.error('Can\'t parse localStorageContent.', error);
        }
        vietmeetLocalStorage.on('changed', onFakeLocalStorageChanged);
    }
}
setupVietMeetLocalStorage();
